const Printer = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 20 22"
		fill="none"
		{...props}
	>
		<path
			stroke="#fff"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.5}
			d="M4.72 12.829c-.24.03-.48.062-.72.096m.72-.096c3.506-.44 7.054-.44 10.56 0m-10.56 0L4.34 17m10.94-4.171c.24.03.48.062.72.096m-.72-.096L15.66 17l.229 2.523a1.123 1.123 0 0 1-1.12 1.227H5.231c-.662 0-1.18-.568-1.12-1.227L4.34 17m0 0H3.25A2.25 2.25 0 0 1 1 14.75V8.456c0-1.081.768-2.015 1.837-2.175a48.031 48.031 0 0 1 1.913-.247M15.658 17h1.091A2.25 2.25 0 0 0 19 14.75V8.456c0-1.081-.768-2.015-1.837-2.175a48.047 48.047 0 0 0-1.913-.247m0 0c-3.49-.38-7.01-.38-10.5 0m10.5 0V2.375c0-.621-.504-1.125-1.125-1.125h-8.25c-.621 0-1.125.504-1.125 1.125v3.659M16 9.5h.008v.008H16V9.5Zm-3 0h.008v.008H13V9.5Z"
		/>
	</svg>
);
export default Printer;
